import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";

import Layout from "./components/Layout";
import Home from "./pages/Home";
import AnalysisBoard from "./pages/AnalysisBoard";
import About from "./pages/About";

function App() {
  return (
    <Router>
      <CssBaseline /> {/* Apply baseline CSS for Material-UI */}
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/analysis" element={<AnalysisBoard />} />
          <Route path="/about" element={<About />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
